export default "__VITE_ASSET__BFwIu5RL__"